<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name:'finance'
    }
</script>

<style lang="scss" scoped>

</style>